<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">
          {{ $tc('delete_ip') }}?
        </v-card-title>
        <v-card-text>
          {{ $t('confirm_ip_delete') }}
          <strong>{{ ip }}</strong>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="green darken-1" text @click.native="closeModal">
            {{ $t('cancel') }}
          </v-btn>
          <v-btn color="text_red" text @click.native="deleteIp">
            {{ $t('confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>

export default {
  props: {
    ip: {
      type: String,
      required: false,
      default: () => null
    },
    open: {
      type: Boolean,
      required: false,
      default: () => false
    }
  },
  data () {
    return {
      dialog: this.open
    }
  },
  computed: {
    netInfo () {
      return this.$store.state.hsm.netInfo
    },
    statInfo () {
      return this.$store.state.hsm.statInfo
    }
  },
  methods: {
    closeModal () {
      this.dialog = false
      this.$emit('close')
    },
    deleteIp () {
      let targetsList = this.netInfo.snmp.targets

      targetsList = targetsList.map((item) => {
        if (item === this.ip) {
          return ''
        } else {
          return item
        }
      })

      const target0 = targetsList[0] !== undefined ? targetsList[0] : ''
      const target1 = targetsList[1] !== undefined ? targetsList[1] : ''
      const target2 = targetsList[2] !== undefined ? targetsList[2] : ''
      const target3 = targetsList[3] !== undefined ? targetsList[3] : ''

      this.$store
        .dispatch('hsm/set_snmp_config', {
          body: {
            hsm_alias: this.statInfo.hsm_alias.toString(),
            community: this.netInfo.snmp.community.toString(),
            sys_contact: this.netInfo.snmp.sys_contact.toString(),
            sys_location: this.netInfo.snmp.sys_location.toString(),
            target0,
            target1,
            target2,
            target3
          }
        })
        .then(() => {
          this.$notify.success({})
        })
        .catch(err => {
          const errObj = this.$store.getters['error/getErrorObj'](err)
          if (errObj) {
            this.$notify.hsmError(errObj, err)
          } else {
            this.$notify.error({ message: err })
          }
        })
        .finally(() => {
          this.loading = false
          this.closeModal()
        })
    }
  },
  watch: {
    open (val) {
      this.dialog = val
    }
  }
}
</script>
